import { type OasisTaskViewModel } from '@generated';
import type { FormikValues } from 'formik';

export function skipOasisQuestion(task: OasisTaskViewModel, formValues: FormikValues) {
	if (!task.oasisDefinition.oasisCodes || task.oasisDefinition.oasisCodes.length === 0 || !task.oasisDefinition.documentationFormFields) {
		return false;
	}

	return task.oasisDefinition.documentationFormFields.every(x => formValues?.[x.name] === '^');
}
